import type { LinkProps } from 'next/link';
import type { AnchorHTMLAttributes } from 'react';
import { forwardRef } from 'react';
import styled from 'styled-components';

import { ensureLocale } from '@/utils/urlUtils';

import type { ButtonProps } from '@/components/Button';
import { Button } from '@/components/Button';
import { useRouter } from '@/hooks/useRouter';

import LinkWithLocale from './LinkWithLocale/LinkWithLocale';

const Link = styled(LinkWithLocale)`
  text-decoration: none;
`;

type LinkButtonProps = ButtonProps &
  Pick<LinkProps, 'href' | 'prefetch'> &
  Pick<AnchorHTMLAttributes<HTMLAnchorElement>, 'rel' | 'target'>;

export const LinkButton = forwardRef<HTMLElement, LinkButtonProps>(
  ({ href, ...props }, ref) => {
    const { locale } = useRouter();
    const localizedHref = ensureLocale(href, locale);

    return (
      <Button
        // @ts-expect-error
        // Button is typed to accept HTMLButtonElement refs only,
        // but when rendered with `as={Link}` it forwards the ref to an <a> element.
        ref={ref}
        as={Link}
        href={localizedHref}
        {...props}
      />
    );
  },
);

LinkButton.displayName = 'LinkButton';
